<template>
  <div class="p-3 bg-secondary-3 rounded">
    <div class="row">
      <div v-for="action in actions" :key="action.value" class="col">
        <action-button
          :id="action.id"
          :text="action.text"
          :variant="actionClasses(action)"
          @click="onActionClickHandler(action)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';

export default {
  name: 'SearchMode',
  components: {
    ActionButton,
  },
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onActionClickHandler(action) {
      const values = this.actions.map((item) => {
        const value = action.id === item.id;
        item.active = value;
        if (value && !item.rendered) item.rendered = true;
        return item;
      });
      this.$emit('update:actions', values);
      this.$emit(
        'change',
        values.find((x) => x.active)
      );
    },
  },
  computed: {
    actionClasses: () => (action) => {
      let val = 'w-100 border-0 font-weight-bold p-2 ';
      if (action.active) val += 'orange';
      val += action.classes || '';
      return val;
    },
  },
};
</script>

<style scoped lang="scss"></style>
